import type { MatchaMetaEligibilityResponse } from '@/pages/api/matcha-meta/eligibility';
import { useQuery } from '@tanstack/react-query';

import { fetcher } from '@/utils/fetcher';
import { isEthereumAddress } from '@/utils/models';
import { routes } from '@/utils/routes';

export const matchaMetaEligibilityQueryKey = (walletAddress: string | undefined) =>
  ['matcha-meta-eligibility', walletAddress] as const;

export const useMatchaMetaEligibility = (walletAddress: string | undefined) => {
  const normalizedAddress = walletAddress?.toLowerCase();
  const shouldFetch = !!normalizedAddress && isEthereumAddress(normalizedAddress);

  return useQuery<MatchaMetaEligibilityResponse, Error>({
    queryKey: matchaMetaEligibilityQueryKey(normalizedAddress),
    queryFn: () =>
      fetcher<MatchaMetaEligibilityResponse>(
        `${routes.api.MATCHA_META_ELIGIBILITY}?walletAddress=${encodeURIComponent(normalizedAddress!)}`,
      ),
    enabled: shouldFetch,
    refetchOnReconnect: false,
  });
};
